import { Component, OnDestroy, OnInit } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { TranslateService } from '@ngx-translate/core';
import {ActivatedRoute} from '@angular/router';
import { ContactService } from '../../services/contact.service';
import { PropertyByNamePipe } from '../../pipes/property-by-name';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html'
})
export class ContactComponent implements OnInit, OnDestroy {

  title = ['_CONTACT.HEADER_1', '_CONTACT.HEADER_2'];

  message: '';
  successMsg: string;
  errorMsg: string;
  private sub: any;

  private id = null;
  private type = null;

  files = [];
  fileUrls: string[];
  fileMessage: string;

  constructor(private api: ApiService,
              private translate: TranslateService,
              private route: ActivatedRoute,
              private contactService: ContactService,
              private propertyByNamePipe: PropertyByNamePipe) { }

  ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
      if (params.type && params.id) {
        this.id = params.id;
        this.type = params.type;
      }
    });

    this.message = this.message = this.translate.instant('DEFAULT_CONTACT_MESSAGE_NO_ITEM');

    switch (this.type) {
      case 'item': {
        this.title[1] = this.translate.instant('YOUR_REQUEST_FOR') + ' "' +
          this.propertyByNamePipe.transform(JSON.parse(this.contactService.item.json).properties, 'Hersteller')
          + ' ' + this.propertyByNamePipe.transform(JSON.parse(this.contactService.item.json).properties, 'Fahrzeugbenennung') + '"';
        break;
      }
      case 'automobilia': {
        this.title[1] = this.translate.instant('YOUR_REQUEST_FOR') + ' "' + this.contactService.automobilia.title + '"';
        this.message = this.translate.instant('DEFAULT_CONTACT_MESSAGE');
        break;
      }
      case 'cars-wanted': {
        this.title[1] = this.translate.instant('YOUR_REQUEST_FOR') + ' "' + this.contactService.carWanted.title + '"';
        this.message = this.translate.instant('DEFAULT_CONTACT_MESSAGE_WANTED_ITEM');
        break;
      }
    }

  }

  ngOnDestroy(): void {
    this.contactService.item = null;
    this.contactService.automobilia = null;
  }

  submit() {
    this.successMsg = this.errorMsg = null;
    const formData = new FormData();

    if (this.type && this.id) {
      let path = 'mail/request-item/' + this.id;
      switch (this.type) {
        case 'item': {
          path = 'mail/request-item/' + this.id;
          this.api.postData(path, this.message).subscribe(res => {
            this.message = '';
            this.successMsg = this.translate.instant('_CONTACT.SUCCESS');
          }, error => {
            console.log('err:', error);
            this.errorMsg = this.translate.instant('_CONTACT.ERROR');
          });
          break;
        }
        case 'automobilia': {
          path = 'mail/request-automobilia/' + this.id;
          this.api.postData(path, this.message).subscribe(res => {
            this.message = '';
            this.successMsg = this.translate.instant('_CONTACT.SUCCESS');
          }, error => {
            console.log('err:', error);
            this.errorMsg = this.translate.instant('_CONTACT.ERROR');
          });
          break;
        }
        case 'cars-wanted': {
          path = 'mail/request-cars-wanted/' + this.id;
          if (this.files && this.files.length > 0) {
            this.files.forEach((file, fileIndex) => {
              formData.append('files', file);
            });
          }
          formData.append('message', this.message);
          this.api.postData(path, formData).subscribe(res => {
            this.message = '';
            this.files = [];
            this.successMsg = this.translate.instant('_CONTACT.SUCCESS');
          }, error => {
            console.log('err:', error);
            this.errorMsg = this.translate.instant('_CONTACT.ERROR');
          });

          break;
        }
      }
    } else {
      this.api.postData('mail/contact-form', this.message).subscribe(res => {
        this.message = '';
        this.successMsg = this.translate.instant('_CONTACT.SUCCESS');
      }, error => {
        console.log('err:', error);
        this.errorMsg = this.translate.instant('_CONTACT.ERROR');
      });
    }

  }

    onFileChanged(event) {
    const mimeType = event.target.files[0].type;
    if (mimeType.match(/image\/*/) === null && mimeType.match(/pdf\/*/) === null) {
      this.fileMessage = 'Only images and pdf files are supported.';
      return;
    }
    const newFiles = Array.from(event.target.files);
    this.files.push(... newFiles);
    this.files.forEach((file, index) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (readerEvent) => {
        if (!this.fileUrls) {
          this.fileUrls = [];
        }
        this.fileUrls.push(reader.result.toString());
      };
    });
  }
    removeTempFile(deleteFile, deleteIndex) {
    this.files = this.files.filter(file => file !== deleteFile);
    this.fileUrls = this.fileUrls.filter((fileUrl, index) => index !== deleteIndex);
  }

}
